export default {
    items: [
        {
            name: 'Задачи',
            url: '/tasks',
            icon: 'fa fa-tasks',
            badge: {
                variant: 'danger',
                text: 'NEW'
            },
            children: [
                {
                    name: 'Текущие задачи',
                    url: '/tasks',
                    icon: 'fa fa-tasks',
                },
                {
                    name: 'Обнаружена ошибка',
                    url: '/tasks/bug-report',
                    icon: 'fa fa-bug',
                },
                {
                    name: 'Запрос функционала',
                    url: '/tasks/feature-request',
                    icon: 'fa fa-bug',
                }
            ]
        },
        {
            name: 'Сообщения',
            url: '/messages',
            icon: 'icon-puzzle',
            badge: {
                variant: 'primary',
                text: 'скоро'
            }
        },
        {
            name: 'Звонки',
            url: '/telecalls',
            icon: 'icon-phone'  ,
        },
        {
            name: 'Отчеты документы',
            url: '/reports-docs',
            icon: 'icon-book-open',
        },
        {
            name: 'Не влезать',
            url: '/lines',
            icon: 'fa fa-circle',
        },
        {
            name: 'Справка',
            url: '/help',
            icon: 'cui-info'  ,
        },
    ]
}
